<template>
  <div class="Notes">
    <ckeditor
      :editor="editor"
      v-model="textNotes"
      :config="editorConfig"
    ></ckeditor>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
//import Vue from "vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  name: "notes",
  data() {
    return {
      textNotes: "",
      placeholdertext: "blank",
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        placeholder: this.placeholdertext, //"wonder what ought to go in this box",
        toolbar:['heading','bold','italic','link','numberedList', 'bulletedList','|','indent','outdent','|','insertTable','undo','redo'],
        heading: {
          options:[
            {model:'paragraph',title:'Paragraph',class:'ck-heading_paragraph'},
            {model:'heading1',view:'h1',title:'Heading 1',class:'ck-heading_heading1'},
            {model:'heading2',view:'h2',title:'Heading 2',class:'ck-heading_heading2'},
            {model:'heading3',view:'h3',title:'Heading 3',class:'ck-heading_heading3'},
          ]
        }
      },
    };
  },
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component,
  },
  methods: {
    ...mapMutations(["updateTextNotes"]),
    captureText: function () {
      console.log("updating text notes");
      this.$store.commit("updateTextNotes", "<html><link rel=\"stylesheet\" type=\"text/css\" href=\"http://forum.burghfieldcameraclub.co.uk/forum.css\"><body>" + this.textNotes + "</body></html>");
    },
  },
  beforeCreate() {
    let path = this.$route.path;
    console.log(ClassicEditor.defaultConfig.toolbar);
    let result = path.match(".*incoming.*");
    if (result) {
      this.placeholdertext = "What needs doing to this image?";
    } else {
      this.placeholdertext = "How have you altered this image?";
    }
    console.log("placeholder " + this.placeholdertext);
  },
  computed: {
    parsedNotes() {
      return "<html><link rel=\"stylesheet\" type=\"text/css\" href=\"http://forum.burghfieldcameraclub.co.uk/forum.css\"><body>" + this.textNotes + "</body></html>";
    },
  },
  watch: {
    parsedNotes() {
      console.log("updating text notes");
      this.$store.commit(
        "updateTextNotes",
        "<html><link rel=\"stylesheet\" type=\"text/css\" href=\"http://forum.burghfieldcameraclub.co.uk/forum.css\"><body>" + this.textNotes + "</body></html>"
      );
    },
  },
};
</script>
